var time1,time1a,time2,time3,time4; //debug varaibles
var flightMap = [];

$(document).ready(function(){

	flightMap = $("#link-table").find("tr[gr=a]").map(function(){
		
		$this = $(this);
		
		return {
				
				fRow: $this.get(0),
				dRow: $this.next().get(0),
				price: parseFloat($this.attr("price")),
				depDate: parseTRDate($this.attr("firstLegDeparture")),
				arrDate: parseTRDate($this.attr("lastLegArrival")),
				rDepDate: parseTRDate($this.attr("rFirstLegDeparture")),
				rArrDate: parseTRDate($this.attr("rLastLegArrival")),
				flighttime: parseFloat($this.attr("flighttime")),
				rFlighttime: parseFloat($this.attr("rflighttime")),
				airlinename: $this.attr("airlinename")
				
				
		};
		
	});
		
	$("[name=sortingSearch]").change(function(){
		
		var $this = $(this).next();
		//var $option = $this.find(":selected");
		
		var attribute = $this.attr("data-filter-attribute");
		var direction = $this.attr("data-filter-direction");
		
		sortFlightList(attribute,direction);
		
		pageIndex = 0;
		refreshTable();
		
	});
    $("#sortingPriceAsc").click();
});

function sortFlightList(attribute,direction){
	
	openLoaderBox();
	
	time1 = new Date();
	
	var table = $("#link-table");
	
	time1a = new Date();
	
	//sortList
	for(var i = 0; i < flightMap.length - 1; i++){
		for(var j = i + 1; j < flightMap.length; j++){
			
			var result = flightMap[i][attribute] > flightMap[j][attribute] ? 1 : (flightMap[i][attribute] < flightMap[j][attribute] ? -1 : 0);
			if(direction == "desc"){
				result *= -1;
			}
			
			if(result == 1){
				var temp = flightMap[i];
				flightMap[i] = flightMap[j];
				flightMap[j] = temp;
			}
		}
	}
		
	
	time2 = new Date();
	
	flightMap.each(function(){
		table.append(this.fRow);
		table.append(this.dRow);		
	});
	
	time3 = new Date();
	
	refreshTable();
	
	closeLoaderBox();
	
	time4 = new Date();
}



function parseTRDate(dateString) {
	
	if(dateString == ""){
		return null;
	}
	
	var parts = dateString.split(' ');
	var dateParts = parts[0].split('.');
	var timeParts = parts[1].split(':');

	var date = new Date(dateParts[2], parseInt(dateParts[1], 10) - 1, dateParts[0], timeParts[0], timeParts[1], 0, 0);

	return date;
}